import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "GrowthVibe - Premier IT & Digital Marketing Agency",
  description = "Elevate your brand with strategic marketing solutions. We specialize in web development, SEO, and digital marketing to drive growth and maximize ROI.",
  keywords = "digital marketing, web development, SEO services, social media marketing, IT agency, brand identity, website design, GrowthVibe, marketing solutions",
  image = "/og-image.svg",
  url = "https://growthvibe.com",
  type = "website",
  structuredData = null
}) => {
  const fullTitle = title.includes('GrowthVibe') ? title : `${title} | GrowthVibe`;
  const fullUrl = url.startsWith('http') ? url : `https://growthvibe.com${url}`;
  const fullImage = image.startsWith('http') ? image : `https://growthvibe.com${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="GrowthVibe Team" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="GrowthVibe" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImage} />
      <meta property="twitter:site" content="@growth_vibe" />
      <meta property="twitter:creator" content="@growth_vibe" />
      
      {/* Additional SEO Meta Tags */}
      <meta name="theme-color" content="#3a7bd5" />
      <meta name="msapplication-TileColor" content="#3a7bd5" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="GrowthVibe" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
